import useTLO from "./useTLO"

export default function useCompany(id) {
  return useTLO("company", id)
}
